import { IGlobalData } from 'global';
import globalData from './globalData.generated';

const json = globalData['json'] as unknown as IGlobalData;
const meta = globalData['meta'];

export { json as globalData, meta as globalDataMeta };
